import { connect, history, useActivate } from 'umi';
import { Button, message, Switch, Table, MessageBox, Row, Col } from 'kenshin';
import TablePro from '@/components/TablePro';
import { useEffect, useRef, useState } from 'react';
import {
  closeprocessapply,
  getcompleteprocess,
} from '@/_serveice/admin/process';
import RecordModal from './components/RecordModal';

import busiTypeKey, { attendanceKey } from '../../../process/_util/busiTypeKey';
import CollapseSearch from '../components/CollapseSearch';
const {
  CUSTOMER,
  CONTRACT,
  PROJECT,
  TASK,
  ROLE,
  OSA,
  WEEK,
  OSAEDIT,
  WEEKEDIT,
  ATTENDANCECHANGE,
} = busiTypeKey;

export const formUrl = [
  '/attendance/apply/applyDetail',
  '/performance/assessment/weeklyPlan',
  '/performance/assessment/OSA/OSAsetting',
  '/performance/assessment/scoreSetting',
  '/performance/assessment/OSA/OSADetail',
  '/process/createProcess/changePage',
  '/process/businessLog/ChangeRecord',
  // '/process/businessLog/ChangeRecord',
  '/performance/selfosa/changosa',
  '/process/pendingBusiness/auditPage',
  '/performance/assessment/levelSetting',
];

const scoreList = [
  'SCORE_ONE_NODE',
  'SCORE_TWO_NODE',
  'SCORE_THREE_NODE',
  'SUMMER_WEEK_PLAN_ONE_NODE',
  'SCORE_WEEK_PLAN_ONE_NODE',
  'HR_CONFIRM_WEEK_PLAN_NODE',
  'HR_PRE_CONFIRM_WEEK_PLAN_NODE',
];
const levelList = ['GRAD_NODE'];

//

const showTodoBtn = (row) => {
  let shouldShowKey = [
    OSA,
    WEEK,
    OSAEDIT,
    WEEKEDIT,
    ATTENDANCECHANGE,
    ...Object.values(attendanceKey),
  ];
  if (shouldShowKey.includes(row.todoItemBusiType)) {
    return true;
  }
  return (
    row.processApplyBeginNodeId == row.processApplyNodeId &&
    row.commitMuIdStr == localStorage.getItem('muId')
  );
};

const showAuditBtn = (row) => {
  let shouldHideKey = [
    OSA,
    WEEK,
    OSAEDIT,
    WEEKEDIT,
    ATTENDANCECHANGE,
    ...Object.values(attendanceKey),
  ];
  if (shouldHideKey.includes(row.todoItemBusiType)) {
    return false;
  }
  return row.processApplyBeginNodeId != row.processApplyNodeId;
};

const ProcessList = ({ usercenter, dispatch, process, system }) => {
  const tableRef = useRef();
  const curData = useRef();
  const [recordVisible, setRecordVisible] = useState(false);

  useActivate(() => {
    dispatch({
      type: 'usercenter/completeitemstat',
      payload: {},
    });
    dispatch({
      type: 'usercenter/gettodoitemnewpage',
    });
  });

  useEffect(() => {
    dispatch({
      type: 'systemOrgani/getAllEmployee',
    });
    getTodoSearchNum();
    dispatch({
      type: 'usercenter/completeitemstat',
      payload: {},
    });
    // getcompleteprocess({ processApplyId: 17 });
  }, []);

  const getTodoSearchNum = (payload = {}) => {
    dispatch({
      type: 'usercenter/todoitemstat',
      payload,
    });
  };

  const publicGo = (params, newData) => {
    dispatch({
      type: 'process/save',
      payload: {
        changeInfo: { data: newData, params },
      },
    });
    history.push({
      pathname: '/process/createProcess/changePage',
      query: {
        type: 'editProcess',
      },
    });
  };

  const osaWeekToDetail = (row) => {
    history.push({
      pathname: '/performance/assessment/OSA/OSADetail',
      query: {
        busiId: row.todoItemBusiId,
      },
    });
  };
  /** 绩效周计划的处理 */
  const osaOrWeekTodo = (row, path) => {
    if (
      [
        'HR_PRE_CONFIRM_WEEK_PLAN_NODE',
        'HR_CONFIRM_WEEK_PLAN_NODE',
        'HR_CONFIRM_NODE',
        'AUDIT_WEEK_PLAN_TWO_NODE',
        'AUDIT_WEEK_PLAN_THREE_NODE',
        'HR_PRE_CONFIRM_NODE',
      ].includes(row.processApplyNodeNumber)
    ) {
      osaWeekToDetail(row);
      return;
    }
    console.log(22222, row, path);
    history.push({
      pathname: path,
      query: {
        busiId: row.todoItemBusiId,
        // muId: row.applyMuId,
        // target: 'E',
      },
    });
  };

  /** 评分之前校验 */
  const checkHasChangeOSA = async (row) => {
    let hasChange = false;
    if (
      [
        'SCORE_ONE_NODE',
        'SCORE_TWO_NODE',
        'SCORE_THREE_NODE',
        'GRADE_NODE',
        'HR_PRE_CONFIRM_NODE',
        'HR_CONFIRM_NODE',
        'OSA_END_NODE',
        'SUMMER_WEEK_PLAN_ONE_NODE',
        'SCORE_WEEK_PLAN_ONE_NODE',
        'HR_PRE_CONFIRM_WEEK_PLAN_NODE',
        'HR_CONFIRM_WEEK_PLAN_NODE',
      ].includes(row.processApplyNodeNumber)
    ) {
      hasChange = await dispatch({
        type: 'performance/haveosachangeprocess',
        payload: {
          osaId: '',
          todoBusiId: row.todoItemBusiId,
        },
      });
    }
    if (hasChange) {
      message.error('该绩效有正在进行的变更修改，无法执行当前操作！');
    }
    return hasChange;
  };

  /** 考勤相关 */
  let getAttendanceKeyFn = () => {
    let obj = {};
    const fun = (_params, _newData, row) => {
      let id = row.todoItemBusiId;
      let busiId = undefined;
      let todoItemBusiType = undefined;
      console.log(
        'getAttendanceKeyFn...',
        row.applyBusiType,
        row.todoItemeExtendBusiId,
      );
      if (row.todoItemBusiType == '16') {
        id = row.todoItemeExtendBusiId;
        busiId = row.todoItemBusiId;
        todoItemBusiType = '16';
      }

      history.push({
        pathname: '/attendance/apply/applyDetail',
        query: {
          id: id,
          busiId: busiId,
          todoItemBusiType,
        },
      });
    };

    Object.values(attendanceKey).forEach((item) => (obj[item] = fun));
    return obj;
  };

  /** 根据不同的业务类型进行不同的处理 */
  const typeOption = {
    [CUSTOMER](params, newData) {
      dispatch({
        type: 'usercenter/save',
        payload: {
          createProcessData: params,
        },
      });
      dispatch({
        type: 'customer/save',
        payload: {
          editData: newData,
        },
      });
      history.push({
        pathname: '/customer/newCustomer',
        query: {
          custId: newData.custId,
          type: 'editProcess',
        },
      });
    },
    [CONTRACT]: publicGo,
    [PROJECT](params, res) {
      publicGo(params, res.newData);
    },
    [TASK]: publicGo,
    [ROLE]: publicGo,
    async [OSA](_params, _newData, row) {
      let hasChange = await checkHasChangeOSA(row);
      if (hasChange) {
        return;
      }
      let path = '/performance/assessment/OSA/OSAsetting';
      // 评分
      if (scoreList.includes(row.processApplyNodeNumber)) {
        path = '/performance/assessment/scoreSetting';
      }
      if (
        [
          'GRADE_NODE',
          'HR_CONFIRM_NODE',
          'HR_PRE_CONFIRM_NODE',
          'AUDIT_WEEK_PLAN_THREE_NODE',
          'HR_PRE_CONFIRM_WEEK_PLAN_NODE',
          'HR_CONFIRM_WEEK_PLAN_NODE',
          'AUDIT_WEEK_PLAN_THREE_NODE',
        ].includes(row.processApplyNodeNumber)
      ) {
        path = '/performance/assessment/levelSetting';
      }
      osaOrWeekTodo(row, path);
    },
    async [WEEK](_params, _newData, row) {
      let hasChange = await checkHasChangeOSA(row);
      if (hasChange) {
        return;
      }
      let path = '/performance/assessment/weeklyPlan';
      if (scoreList.includes(row.processApplyNodeNumber)) {
        path = '/performance/assessment/scoreSetting';
      }
      osaOrWeekTodo(row, path);
    },
    [OSAEDIT](_params, _newData, row) {
      history.push({
        // pathname: '/performance/selfosa/OSAEditAudit',
        pathname: '/performance/selfosa/changosa',
        query: {
          busiId: row.todoItemBusiId,
        },
      });
    },
    [WEEKEDIT](_params, _newData, row) {
      history.push({
        // pathname: '/performance/selfosa/OSAEditAudit',
        pathname: '/performance/selfosa/changosa',
        query: {
          busiId: row.todoItemBusiId,
        },
      });
    },
    ...getAttendanceKeyFn(),

    // [ROLE](params,res){
    //   console.log(params,res);
    //   // publicGo
    // },
  };

  /** 处理 */
  const handleTodo = (row) => {
    let params = {
      processApplyId: row.dataChange?.processApplyId,
      todoItemId: row.todoItemId,
      dataChangeId: row.dataChange?.dataChangeId,
      dataChangeBefore: row.dataChange?.dataChangeBefore,
      busiType: row.todoItemBusiType,
    };
    const newData = JSON.parse(row.dataChange?.dataChangeAfter ?? '{}');
    typeOption[row.todoItemBusiType]?.(params, newData, row);
  };

  /** 审核 */
  const handleAudit = (row) => {
    dispatch({
      type: 'usercenter/save',
      payload: {
        createProcessData: row,
      },
    });
    history.push({
      pathname: '/process/pendingBusiness/auditPage',
      query: {},
    });
  };

  const closeApply = (row) => {
    MessageBox.confirm({
      title: '确认操作',
      content: '确认关闭？关闭后无法恢复',
      onOk: () => {
        closeprocessapply(row).then((res) => {
          if (res.success) {
            tableRef.current.reload();
            message.success('关闭成功');
          }
        });
      },
    });
  };

  const columnsObj = {
    columns: [
      {
        dataIndex: 'todoItemName',
        title: '业务名称',
      },
      {
        dataIndex: 'todoItemBusiType',
        title: '业务类型',
        render: (val) => process.processTypeStrObj[val],
      },
      {
        dataIndex: 'gmtCreate',
        title: '提交时间',
        render: (time) => moment(time).format('YYYY-MM-DD HH:mm:ss'),
      },
      {
        dataIndex: 'commitMuname',
        title: '提交人',
      },
      {
        dataIndex: 'curnProcessNodeName',
        title: '当前流程',
        render(text, row) {
          return (
            <Button
              type="text"
              onClick={() => {
                curData.current = row;
                setRecordVisible(true);
              }}
            >
              {text}
            </Button>
          );
        },
      },
      {
        key: 'options',
        width: 100,
        title: '操作',
        render: (row) => {
          return (
            <Row>
              {showTodoBtn(row) && (
                <Col span={10}>
                  <Button type="text" onClick={() => handleTodo(row)}>
                    处理
                  </Button>
                </Col>
              )}
              {showAuditBtn(row) && (
                <Col span={10}>
                  <Button type="text" onClick={() => handleAudit(row)}>
                    审核
                  </Button>
                </Col>
              )}
              {/* <Col span={10}>
                <Button
                  type="text"
                  onClick={() => {
                    curData.current = row;
                    setRecordVisible(true);
                  }}
                >
                  记录
                </Button>
              </Col> */}
              {row.commitMuIdStr == localStorage.getItem('muId') &&
                row.processApplyBeginNodeId == row.processApplyNodeId &&
                row.applyStatus == -1 && (
                  <Col span={10}>
                    <Button
                      type="text"
                      style={{ color: 'red' }}
                      onClick={() =>
                        closeApply({
                          processApplyList: [row.dataChange?.processApplyId],
                        })
                      }
                    >
                      关闭
                    </Button>
                  </Col>
                )}
            </Row>
          );
        },
      },
    ],
  };

  const handleSubmit = (props) => {
    // 假如是从处理页面返回，则回显上次的搜索结果
    if (formUrl.includes(system.router.to)) {
      // console.log(11111111,usercenter.businessPendSearchData)
      props.key = usercenter.businessPendSearchData.key;
      props.busiType = usercenter.businessPendSearchData.busiType;
      props.statBeginTime = usercenter.businessPendSearchData.statBeginTime;
      props.statEndTime = usercenter.businessPendSearchData.statEndTime;
    }
    return props;
  };

  return (
    <div>
      <CollapseSearch
        onChange={tableRef.current?.reload}
        searchChange={getTodoSearchNum}
        data={usercenter?.todoSearchNum || {}}
      />
      <TablePro
        request="usercenter/gettodoitemnewpage"
        // searchCloumns={searchCloumns}
        rowKey={'todoItemId'}
        data={usercenter.todoPageList}
        actionRef={(ref) => (tableRef.current = ref)}
        // rowSelection={{
        //   type: 'checkbox',
        //   ...rowSelection,
        // }}
        onSubmit={handleSubmit}
        curColumns
        {...columnsObj}
      ></TablePro>
      <RecordModal
        visible={recordVisible}
        row={curData.current}
        processApplyId={curData.current?.dataChange?.processApplyId}
        onCancel={() => {
          setRecordVisible(false);
        }}
      />
    </div>
  );
};

export default connect(({ process, usercenter, system }) => ({
  process,
  system,
  usercenter,
}))(ProcessList);
